import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterErroComprometimentoEntrega(entregaId) {
        return axiosJwt
            .get(
                `${api}/credenciados/gerentes/movimentos/entrega/${entregaId}/erro`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterErroComprometimentoDespViagem(codContracao, tipo) {
        return axiosJwt
            .get(
                `${api}/credenciados/gerentes/movimentos/despviagem/${codContracao}/${tipo}/erro`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
